import axios from 'axios'
import { URIS } from '../Uris'
import { errorMessage } from '../helpers'

export const DO_LOGIN = 'DO_LOGIN'
export const DO_LOGIN_LOADING = 'DO_LOGIN_LOADING'
export const DO_LOGIN_SUCCESS = 'DO_LOGIN_SUCCESS'
export const DO_LOGIN_FAILURE = 'DO_LOGIN_FAILURE'
export const DO_LOGOUT = 'DO_LOGOUT'

export function callLogin(payload) {
  return (dispatch) => {
    dispatch(doLogin())
    axios({
      method: 'POST',
      url: URIS.login,
      headers: URIS.axiosHeaders,
      data: payload
    })
      .then((res) => {
        dispatch(doLoginSuccess(res.data))
      })
      .catch((error) => {
        dispatch(doLoginFailure(errorMessage(error)))
      })
  }
}

function doLogin() {
  return {
    type: DO_LOGIN
  }
}

export function doLoginSuccess(payload) {
  return {
    type: DO_LOGIN_SUCCESS,
    payload
  }
}

function doLoginFailure(payload) {
  return {
    type: DO_LOGIN_FAILURE,
    payload
  }
}

export function callLogout() {
  return {
    type: DO_LOGOUT
  }
}



// WEBPACK FOOTER //
// ./src/actions/Auth.js